import * as React from "react"
import base from "../resources/text/base"

export const CurrentLanguageContext = React.createContext(base)


export const useText = () => React.useContext(CurrentLanguageContext);